<script setup lang="ts">
type Props = {
  src: string;
  alt?: string;
};

withDefaults(defineProps<Props>(), {
  alt: "",
});

const emit = defineEmits(["load", "error"]);

const root = ref<HTMLImageElement>();

const loaded = ref(false);

const onLoad = () => {
  loaded.value = true;
  emit("load", root.value);
};

const onError = () => emit("error", root.value);
</script>

<template>
  <img
    v-lazy="src"
    :class="['v-lazy-image', { 'v-lazy-image-loaded': loaded }]"
    :alt="alt"
    @load="onLoad"
    @error="onError"
  />
</template>

<style scoped>
.v-lazy-image {
  opacity: 0;
  transition: opacity 2s;
}

.v-lazy-image-loaded {
  opacity: 1;
}
</style>
